/* eslint-disable max-len */
import { Grid } from '@chakra-ui/react';
import React from 'react';
import {
    Button, Image, Text,
} from 'shared';
// eslint-disable-next-line no-restricted-imports
import CEOImage from 'shared/assets/Gennadij_Hohryakov_46cee94d8f_3803f71f20.png';
// eslint-disable-next-line no-restricted-imports
import { Helmet } from 'react-helmet-async';
import { useFeedbackPageState } from '../model';

export const FeedbackPage = () => {
    const {
        logoImage,
        feedbackContacts,
    } = useFeedbackPageState();

    return (
        <Grid height="100vh" width="100vw" position="relative">
            <Helmet>
                <title>Обратная связь Corso Catering</title>
                <meta name="description" content="Если у Вас есть замечания или рекомендации по улучшению сервиса  Corso Catering, буду признателен Вам за информацию." />
                <meta property="og:title" content="Обратная связь Corso Catering" />
            </Helmet>
            <Grid width="100vw" position="relative" zIndex={2} backdropFilter="blur(10px)">
                <Grid
                    margin="auto"
                    width={{
                        base: '80vw',
                        lg: '30vw',
                    }}
                    padding="2rem"
                >
                    <Grid gap="2rem">
                        <Grid margin="0 auto" background="#ffffff" pos="relative" width="70%">
                            <Image src={logoImage?.url} width="100%" />
                        </Grid>
                        <Grid templateColumns="1fr 2fr" gap="2rem">
                            <Image src={CEOImage} width="100%" aspectRatio="1 / 1" objectFit="cover" borderRadius="100%" />
                            <Text fontSize="1.5rem">
                                Добрый день. Если у Вас есть замечания или рекомендации по улучшению сервиса  Corso Catering, буду признателен Вам за информацию.
                                <br />
                                <br />
                                С уважением Геннадий Хохряков. CEO Corso Catering
                            </Text>
                        </Grid>
                        <Grid gap="0.5rem">
                            {feedbackContacts.map((contact) => (
                                <Button size="2xl" fontSize="1.5rem" background="#ffffff" color="#000000" border="1px solid #000000" onClick={() => { window.location.href = contact.link || ''; }}>
                                    <Image src={contact.image?.url} height="1.5rem" />
                                    {contact.title}
                                </Button>
                            ))}
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};
